import { useState } from "react";
import { Send, Loader2, Clock } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { ACTIONS, COUNTERPARTIES, POLICY, evaluate, fmt } from "./lifecyclePolicy";
const VERDICT = { approved: "text-swarm-green", escalate: "text-amber-400", deny: "text-rose-400" };

export const ProposePanel = ({ onPropose, pending, running }) => {
  const [action, setAction] = useState("pay");
  const [amount, setAmount] = useState("4200");
  const [counterparty, setCounterparty] = useState("vendor-7f3a");
  const amt = Math.max(0, Number(amount) || 0);
  const preview = evaluate({ action, amount: amt, counterparty });
  const busy = Boolean(pending || running);

  return (
    <div className="mt-6 glass-card p-5 md:p-6 border-swarm-violet/20" data-testid="propose-panel">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1">
          <div className="section-label mb-2">Propose your own action</div>
          <p className="text-slate-400 text-sm">
            Policy: auto-approve ≤ ${fmt(POLICY.autoApprove)} · escalate to human ≤ ${fmt(POLICY.dailyBudget)} · deny above budget or any unknown counterparty.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_0.75fr_1.25fr] gap-3 lg:w-[600px]">
          <Select value={action} onValueChange={setAction}>
            <SelectTrigger data-testid="propose-action-select" className="bg-swarm-darker border-swarm-border"><SelectValue /></SelectTrigger>
            <SelectContent>{ACTIONS.map((a) => <SelectItem key={a.id} value={a.id}>{a.label}</SelectItem>)}</SelectContent>
          </Select>
          <div className="relative">
            <Input type="number" min="0" step="100" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="propose-amount-input" className="bg-swarm-darker border-swarm-border pr-14 font-mono" />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500 font-mono">USDC</span>
          </div>
          <Select value={counterparty} onValueChange={setCounterparty}>
            <SelectTrigger data-testid="propose-counterparty-select" className="bg-swarm-darker border-swarm-border"><SelectValue /></SelectTrigger>
            <SelectContent>{COUNTERPARTIES.map((c) => <SelectItem key={c.id} value={c.id}>{c.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <Button onClick={() => onPropose({ action, amount: amt, counterparty })} disabled={busy} className="bg-swarm-violet hover:bg-swarm-violet/90 text-white rounded-full px-6 min-w-[170px]" data-testid="propose-action-btn">
          {running ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : pending ? <Clock className="w-4 h-4 mr-2" /> : <Send className="w-4 h-4 mr-2" />}
          {running ? "Evaluating…" : pending ? "Queued · up next" : "Propose action"}
        </Button>
      </div>
      <div className="mt-3 font-mono text-xs text-slate-500" data-testid="propose-preview">
        policy preview → <span className={`font-semibold uppercase ${VERDICT[preview.outcome]}`}>{preview.outcome}</span> · {preview.reason}
      </div>
    </div>
  );
};
